import * as React from "react";
import { TextInput, SelectInput, NumberInput, DateTimeInput, Create, required } from "react-admin";
import { Grid } from "@mui/material";
import {
  NotificationTypeEnum,
  StatusEnum,
} from "../../common/enum";
import Transformer from "../../common/Transformer";
import { SimpleForm} from "src/enterprise/ra-rbac";
import { NotificationCreateComponent } from "./NotificationComponent";
import { FileInput } from "src/components/file-input";

export const NotificationCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        fromDate:
          typeof data["from_date"] === "string" ||
          typeof data["from_date"] === "undefined"
            ? data["from_date"]
            : (data["from_date"] as Date).toISOString(),
        toDate:
          typeof data["to_date"] === "string" ||
          typeof data["to_date"] === "undefined"
            ? data["to_date"]
            : (data["to_date"] as Date).toISOString(),
      },
    });
    return data;
  };
  return (
    <Create transform={transform} component={NotificationCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={6}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput validate={required()} source="status" choices={StatusEnum} />
          </Grid>
          <Grid item sm={12} md={4}>
            <SelectInput
              validate={required()}
              source="type"
              choices={NotificationTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="from_date"/>
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="to_date"/>
          </Grid>
          <Grid item sm={12} md={6}>
            <FileInput
              source="image"
              label="Image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP"]}
              multiple={false}
              required
              validate={required()}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <FileInput
              source="mobile_image"
              label="Mobile Image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP"]}
              multiple={false}
            /> 
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
